import { ROLE_ASSUMTION } from '../constant';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { RoleAssumptionState } from '../types/StateTree';

export const getInitialRoleAssumptionState = (): RoleAssumptionState => {
    const roleAssumptionUserName = sessionStorage.getItem(ROLE_ASSUMTION) || '';
    return {
        assumedUserName: roleAssumptionUserName,
        isRoleAssumptionStarted: !!roleAssumptionUserName,
        isValidRoleAssumptionUser: true,
        requestStatus: ApiRequestStatus.Idle
    };
};
